import { render, staticRenderFns } from "./CriarConta.vue?vue&type=template&id=38717840"
import script from "./CriarConta.vue?vue&type=script&lang=js"
export * from "./CriarConta.vue?vue&type=script&lang=js"
import style0 from "./CriarConta.vue?vue&type=style&index=0&id=38717840&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports